<button #trigger="matMenuTrigger" [matMenuTriggerFor]="descriptionEmoji" aria-label="Open Emojis" color="primary"
        mat-icon-button>
    <mat-icon>sentiment_very_satisfied</mat-icon>
</button>
<mat-menu #descriptionEmoji="matMenu" aria-label="Emoji picker" class="emojiMenu">
    <emoji-mart (click)="stopClose($event)" (emojiClick)="addEmoji($event, trigger)" (keyup.enter)="stopClose($event)"
                [style]="{ width:'280px' }"
                aria-label="Emoji picker"
                emoji="smile" title="Select"></emoji-mart>
</mat-menu>
